import { render, staticRenderFns } from "./BaseDropdownToggle.vue?vue&type=template&id=4ce4072d&scoped=true"
import script from "./BaseDropdownToggle.vue?vue&type=script&lang=js"
export * from "./BaseDropdownToggle.vue?vue&type=script&lang=js"
import style0 from "./BaseDropdownToggle.vue?vue&type=style&index=0&id=4ce4072d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce4072d",
  null
  
)

export default component.exports